import { render, staticRenderFns } from "./TaskTemplate.vue?vue&type=template&id=128c0d27&scoped=true"
import script from "./TaskTemplate.vue?vue&type=script&lang=js"
export * from "./TaskTemplate.vue?vue&type=script&lang=js"
import style0 from "./TaskTemplate.vue?vue&type=style&index=0&id=128c0d27&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "128c0d27",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('128c0d27')) {
      api.createRecord('128c0d27', component.options)
    } else {
      api.reload('128c0d27', component.options)
    }
    module.hot.accept("./TaskTemplate.vue?vue&type=template&id=128c0d27&scoped=true", function () {
      api.rerender('128c0d27', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/preScreening/task/TaskTemplate.vue"
export default component.exports